/**
 * Pieces that arrange others: column, row, list, and the divider line.
 */
import { For, type JSX } from "solid-js";
import type { UiNode } from "@protocol/UiNode";
import type { UiContext } from "./context";

/** Children one under the other. */
export function UiColumn(props: { children: UiNode[]; ctx: UiContext }): JSX.Element {
  return (
    <div class="ui-column" data-ui="column">
      <For each={props.children}>{(child) => props.ctx.render(child)}</For>
    </div>
  );
}

/** Children side by side (wrapping when narrow). */
export function UiRow(props: { children: UiNode[]; ctx: UiContext }): JSX.Element {
  return (
    <div class="ui-row" data-ui="row">
      <For each={props.children}>{(child) => props.ctx.render(child)}</For>
    </div>
  );
}

/** A list, one item per line. */
export function UiList(props: { items: UiNode[]; ctx: UiContext }): JSX.Element {
  return (
    <ul class="ui-list" data-ui="list">
      <For each={props.items}>{(item) => <li>{props.ctx.render(item)}</li>}</For>
    </ul>
  );
}

/** A thin line between parts. */
export function UiDivider(): JSX.Element {
  return <hr class="ui-divider" data-ui="divider" />;
}
